// KeyPointAlongSideIconComponent.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollFadeWrapper, {
  ScrollFadeSection,
} from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import Image from '../../Image/Image';

const KEYPOINT_VECTOR_URL =
  'https://assets.askhippo.co.za/Vectors/KeyPointVerticalVector.svg';

const renderFormattedText = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) => {
    if (/^\*\*[^*]+\*\*$/.test(part)) {
      return (
        <strong key={i} style={{ fontWeight: 700 }}>
          {part.slice(2, -2)}
        </strong>
      );
    }

    return part;
  });

const KeyPointAlongSideIconComponent = ({ data }) => {
  const { title, description, footer, steps } = data;

  return (
    <ScrollFadeSection
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box sx={{ width: '1320px', display: 'flex', alignItems: 'flex-start' }}>
        <Box
          sx={{
            position: 'sticky',
            top: '120px',
            width: '430px',
            backgroundColor: '#162F3B',
            borderRadius: '48px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            boxSizing: 'border-box',
            padding: '40px',
            zIndex: 2,
            flexShrink: 0,
            marginRight: '30px',
            alignSelf: 'flex-start',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '3.5rem',
              lineHeight: '4rem',
              color: '#FFFFFF',
              mb: '32px',
              maxWidth: '360px',
              textAlign: 'center',
              whiteSpace: 'pre-line',
            }}
          >
            {title}
          </Typography>

          {description && (
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: '1.625rem',
                lineHeight: '2rem',
                color: '#FFFFFF',
                mb: '32px',
                maxWidth: '360px',
                textAlign: 'center',
                whiteSpace: 'pre-line',
              }}
            >
              {description}
            </Typography>
          )}

          {footer && (
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                fontSize: '0.75rem',
                lineHeight: '1.25rem',
                color: '#FFFFFF',
                textAlign: 'center',
              }}
            >
              {footer}
            </Typography>
          )}
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '40px',
            width: '855px',
            paddingBottom: 0,
            borderRadius: '48px',
            boxSizing: 'border-box',
          }}
        >
          {steps.map(({ icon, title, text }, index) => (
            <ScrollFadeWrapper key={index} delay={index * 0.1}>
              <Box
                sx={{
                  width: '855px',
                  backgroundColor: '#FFFFFF',
                  borderRadius: '40px',
                  padding: '42px 48px',
                  boxSizing: 'border-box',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '50px',
                  boxShadow:
                    '0px 1px 2px 0px #A2ACB133, 0px 12px 24px -4px #162F3B1F',
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    width: '144px',
                    height: '144px',
                    flexShrink: 0,
                  }}
                >
                  <Image
                    width={144}
                    height={144}
                    src={KEYPOINT_VECTOR_URL}
                    alt=""
                    aria-hidden="true"
                    sx={{ width: '100%', height: '100%' }}
                  />
                  <Image
                    width={64}
                    height={64}
                    src={icon}
                    alt=""
                    aria-hidden="true"
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: '64px',
                      height: '64px',
                      objectFit: 'contain',
                    }}
                  />
                </Box>

                <Box sx={{ maxWidth: '570px' }}>
                  <Typography
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 700,
                      fontSize: '1.875rem',
                      lineHeight: '2.25rem',
                      color: '#162F3B',
                      mb: '16px',
                    }}
                  >
                    {title}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: '1.25rem',
                      lineHeight: '1.75rem',
                      color: '#162F3B',
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {renderFormattedText(text)}
                  </Typography>
                </Box>
              </Box>
            </ScrollFadeWrapper>
          ))}
        </Box>
      </Box>
    </ScrollFadeSection>
  );
};

export default KeyPointAlongSideIconComponent;
